import validate from "/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "fetch-help": () => import("/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/middleware/fetchHelp.ts"),
  "fetch-home": () => import("/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/middleware/fetchHome.ts"),
  "set-page-indicator": () => import("/data/teamcity/work/3e35e6dd513854b2/applications/smart-application/middleware/setPageIndicator.ts")
}